import type { MakeCall } from '../createMakeCall';
import { Settlement } from '../types/Settlement';

const getSettlement = (makeCall: MakeCall) => (reference: string) =>
  makeCall<Settlement>('GET', `/api/v2/payment/settlement/${reference}`);
export { getSettlement };
